'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CwShellLeftNavExpand = exports.CwShellLeftNavExpand = {
  COLLAPSED: 'Collapsed',
  DEFAULT: 'Default',
  FAT: 'Fat',
  SKINNY: 'Skinny'
};

var CwShellSizes = exports.CwShellSizes = {
  COLLAPSED: 32,
  DEFAULT: 88,
  FAT: 192,
  SKINNY: 56
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwshellleftnav/constants.js
// module id = 227
// module chunks = 10